// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ-module--faq--1dwMr","question":"FAQ-module--question--1uH1I","open":"FAQ-module--open--2B-3m","answer":"FAQ-module--answer--kX2Zd"};